$item-box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.15);

@keyframes label-svg-spin {
  to {
    stroke-dashoffset: -100;
  }
}


@mixin no-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.label-background {
  background-color: color-mix(in srgb, var(--color-bg-primary) 60%, transparent);
  border: 1px solid var(--color-border-primary);
  border-radius: var(--radius-md);
  padding: 6px 8px;
  transition: top 0.2s ease-in-out;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  width: fit-content;
  position: relative;
  isolation: isolate;
}

.label-content {
  position: relative;
  z-index: 2;
}

.label-shell {
  position: relative;
  width: fit-content;
  overflow: visible;
}

.label-loading-svg {
  display: none;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
  fill: none;
  overflow: visible;
}

.label-loading-svg--visible {
  display: block;
}

.label-loading-svg-arc {
  //vector-effect: non-scaling-stroke;
  stroke: rgba(0, 54, 82, 0.58);
  stroke-width: 3;
  stroke-linecap: round;
  fill: none;
  stroke-dashoffset: 0;
  animation: label-svg-spin 1.4s linear infinite;
}

.label-right {
  display: flex;
  justify-content: flex-end;
  pointer-events: all;
  z-index: 4;

  position: absolute;
  top: 50px;
  right: 0px;
}

.label-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 4px;
  justify-content: flex-end;
  pointer-events: all;
}

.label-row-item {
  background-color: var(--color-bg-subtle);
  border: 1px solid var(--color-border-primary);
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: 0.2rem;
  padding: 4px 12px;

  @include no-select;

  &:hover {
    box-shadow: $item-box-shadow;
    background-color: var(--color-bg-subtle-hover);
  }
}

.label-row-item-group {
  display: flex;
  border-radius: var(--radius-md);

  &:hover {
    box-shadow: $item-box-shadow;
  }

  .label-row-group-item {
    display: flex;
    background-color: var(--color-bg-subtle);
    border: 1px solid var(--color-border-primary);
    border-radius: var(--radius-md);
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: 0px;
    margin-right: 0px;
    padding: 4px 0px;
    border-radius: var(--radius-md);

    svg {
      margin-right: 3px;
    }

    &:not(:first-child) {
      border-left: none;
    }

    &:hover {
      background-color: var(--color-bg-subtle-hover);
    }

    &:first-child {
      padding-left: 12px;
    }

    &:first-child:not(:last-child) {
      border-radius: 4px 0 0 4px;
    }

    &:last-child:not(:first-child) {
      border-radius: 0 4px 4px 0;
    }
  }


}

.coordinate-wrapper {
  padding-right: 8px
}

.tephigram-range {
  background-color: var(--color-bg-primary);
  border: 1px solid var(--color-border-primary);
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: 0.2rem;
  padding: 0.25rem 0.4rem;

  &:hover {
    box-shadow: $item-box-shadow;
  }
}

.label-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 1em;
    height: 1em;
    vertical-align: middle;
    display: inline-block;
  }
}

.location-search-wrapper {
  background: var(--color-bg-subtle);
  border: 1px solid var(--color-border-primary);
  border-radius: var(--radius-md);
  padding: .3rem .4rem;
  cursor: pointer;

  &:hover {
    box-shadow: $item-box-shadow;
    background-color: var(--color-bg-subtle-hover);
  }

  &.location-search-wrapper--active {
    outline: none;
    box-shadow: none;
  }
}

.location-search-wrapper--active {
  // Keep the button neutral; the enclosing cell now shows the active state.
  outline: none;
  box-shadow: none;
}


.divider {
  width: 1px;
  height: 100%;
  background-color: var(--color-gray-500);
  margin: 0;
}

.model-runs {
  background-color: var(--color-bg-primary);
  border: 1px solid var(--color-border-primary);
  border-radius: var(--radius-md);
  margin-top: 0.25rem;
  padding: 0.25rem 0.4rem;
  cursor: pointer;

  .model-runs-header {
    display: grid;
    grid-template-columns: 1fr 1px 1fr 1px 150px;
    column-gap: 1em;
    color: #b0b0b0;
  }

  .model-run {
    display: grid;
    grid-template-columns: 1fr 1px 1fr 1px 150px;
    column-gap: 1em;
    margin-top: 0.4em;
  }
}

.date-description-wrapper {
  background-color: var(--color-bg-subtle);
  border: 1px solid var(--color-border-primary);
  border-radius: var(--radius-md);
  padding: 4px 12px;
  align-items: center;
  display: flex;
  cursor: pointer;

  &:hover {
    background-color: var(--color-bg-subtle-hover);
    box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.15);


  }
}
